var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "billing-counter-container" }, [
    _c("div", { staticClass: "billing-counter-title" }, [
      _vm._v(_vm._s(_vm.text[_vm.type])),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "billing-counter" }, [
      _c(
        "div",
        { staticClass: "billing-counter-button", on: { click: _vm.decrement } },
        [_c("span", { staticClass: "material-icons" }, [_vm._v("remove")])]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "billing-counter-value" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model.number",
              value: _vm.counter,
              expression: "counter",
              modifiers: { number: true },
            },
          ],
          attrs: { type: "number", min: "1" },
          domProps: { value: _vm.counter },
          on: {
            blur: [
              function ($event) {
                _vm.counter = Math.max(1, _vm.counter)
              },
              function ($event) {
                return _vm.$forceUpdate()
              },
            ],
            input: function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.counter = _vm._n($event.target.value)
            },
          },
        }),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "billing-counter-button", on: { click: _vm.increment } },
        [_c("span", { staticClass: "material-icons" }, [_vm._v("add")])]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }